<template>
  <div class="container">
    <div id="toggle-tarif" class="toggles">
      <a
        v-on:click="tarifCollapsed = !tarifCollapsed"
        v-b-toggle.tarifs
        class="title"
      >
        <i :class="[tarifCollapsed ? 'fa-plus' : 'fa-minus active', 'fa']"></i
        >Nos tarifs
      </a>
      <b-collapse id="tarifs" accordion="tarifs" role="tabpanel">
        <div class="row">
          <b-col class="mx-auto" md="10" cols="12">
            <p>
              Nous appliquons les tarifs conventionnés de la CNAM. Le tiers
              payant est effectué uniquement pour les prises en charge en ALD,
              CMU, AMO, AME, et les protocoles de télémédecine. Règlements par
              chèque et espèces.
            </p>
            <p class="note">Nous n'acceptons pas la carte bancaire</p>
            <div class="tables">
              <p class="table-title">{{ titleTarif }}</p>
              <div>
                <b-table bordered hover :items="itemsTarifs"> </b-table>
              </div>
            </div>
          </b-col>
        </div>
      </b-collapse>
    </div>

    <div id="toggle-docs" class="toggles">
      <a
        v-on:click="docCollapsed = !docCollapsed"
        v-b-toggle.docs
        class="title"
      >
        <i :class="[docCollapsed ? 'fa-plus' : 'fa-minus active', 'fa']"></i
        >Documents à apporter le jour du rendez-vous
      </a>
      <b-collapse id="docs" accordion="docs" role="tabpanel">
        <div class="row">
          <b-col class="mx-auto" md="10" cols="12">
            <ul>
              <li>Carte vitale</li>
              <li>
                Moyen de paiement (chèque ou espèces, nous ne prenons pas la CB)
              </li>
              <li>
                Ordonnance en cours de validité (doit être datée de moins de 1
                an avant la date du rdv)
              </li>
            </ul>
            <p class="note">Nous n'acceptons pas la carte bancaire</p>
            <div class="tables">
              <div>
                <b-table bordered hover :fields="fieldsDocs" :items="itemsDocs">
                  <template v-slot:cell(ordonnance)="data">
                    <span v-html="data.value"></span>
                  </template>
                </b-table>
              </div>
            </div>
          </b-col>
        </div>
      </b-collapse>
    </div>

    <div id="rdv">
      <h1>Prise de rendez-vous</h1>

      <b-row>
        <b-col cols="12" md="6">
          <p>Vous pouvez prendre rendez-vous en ligne pour:</p>
          <ul>
            <li>un bilan orthoptique (de tout type)</li>
            <li>un examen de vue ou un renouvellement de lunettes</li>
            <li>un suivi d’amblyopie</li>
            <li>un dépistage de rétinopathie par télémédecine</li>
          </ul>
          <b-row class="text-center">
          <b-col cols="12" md="6">
          <b-button target="_blank" href="https://booking.keldoc.com/cabinet-medical/saint-martin-d-heres-38400/cabinet-d-orthoptie-3#specialty-64" type="button" class="btn-rdv mx-auto">Prendre rendez-vous</b-button>
          </b-col>
          </b-row>
        </b-col>
          <b-col cols="12" md="6">
          <b
            ><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            IMPORTANT:</b
          >
          <div class="warning">
            Pour effectuer
            <u>un examen orthoptique</u> (sauf
            <router-link :to="'/consultations#renouvellement'"
              >renouvellement optique</router-link
            >), il est obligatoire
            <u>d’avoir une ordonnance en cours de validité</u> (moins d’un an).
          </div>
          <div class="warning">
            Pour
            <u>les rééducations</u>, les rendez-vous seront donnés par les
            praticiennes elles-mêmes suite au bilan réalisé initialement.
          </div>
          <div class="warning">
            Pour
            <u>toute demande particulière</u> ou <u>reprise de suivi</u>, merci
            de joindre directement le cabinet par téléphone ou mail en précisant
            le motif de votre demande et vos coordonnées, grâce au
            <a href="/contact">formulaire de contact</a>.
          </div>
        </b-col>
        <!-- <div class="col-sm-6">
          <iframe
            src="https://booking.keldoc.com/cabinet-medical/saint-martin-d-heres-38400/cabinet-d-orthoptie-3#specialty-64"
            class="booking"
          ></iframe>

        </div> -->
          </b-row>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      docCollapsed: true,
      tarifCollapsed: true,
      titleDocs: "Documents à apporter pour le jour du rendez-vous",
      titleTarif:
        "Nomenclature générale des actes les plus courants en orthoptie (tarifs conventionnés CNAM)",
      itemsTarifs: [
        {
          "Dénomination de l’acte":
            "Bilan des troubles oculomoteurs (hétérophories, strabismes, paralysies)",
          "Cotation lettre clé": "AMY 15",
          Tarif: "39,00€",
        },
        {
          "Dénomination de l’acte": "Bilan d’une amblyopie",
          "Cotation lettre clé": "AMY 15,5",
          Tarif: "40,30€",
        },
        {
          "Dénomination de l’acte":
            "Bilan des conséquences neuro-ophtalmologiques des pathologies générales (AVC, SEP) et des déficiences neuro-visuelles d’origine fonctionnelle (TNV, TDN)",
          "Cotation lettre clé": "AMY 30,5",
          Tarif: "79,30€",
        },
        {
          "Dénomination de l’acte":
            "Bilan des déficiences visuelles (basse vision)",
          "Cotation lettre clé": "AMY 30",
          Tarif: "78,00€",
        },
        {
          "Dénomination de l’acte":
            "Mesure de l’acuité visuelle et de la réfraction",
          "Cotation lettre clé": "AMY 8,5",
          Tarif: "22,10€",
        },
        {
          "Dénomination de l’acte":
            "Rééducation d’une déficience visuelle (basse vision) ou fonctionnelle >16 ans, par séance",
          "Cotation lettre clé": "AMY 18",
          Tarif: "46,80€",
        },
        {
          "Dénomination de l’acte":
            "Rééducation d’une déficience visuelle ou fonctionnelle (trouble des apprentissages , TDN…)  < 16 ans, par séance",
          "Cotation lettre clé": "AMY 12",
          Tarif: "31,20€",
        },
        {
          "Dénomination de l’acte": "Traitement du strabisme, par séance",
          "Cotation lettre clé": "AMY 6,5",
          Tarif: "16,90€",
        },
        {
          "Dénomination de l’acte": "Traitement de l’amblyopie, par séance",
          "Cotation lettre clé": "AMY 5,8",
          Tarif: "15,08€",
        },
        {
          "Dénomination de l’acte":
            "Traitement des hétérophories et des déséquilibres binoculaires",
          "Cotation lettre clé": "AMY 4",
          Tarif: "10,40€",
        },
        {
          "Dénomination de l’acte":
            "Dépistage de la rétinopathie diabétique avec lecture différée par télétransmission",
          "Cotation lettre clé": "AMY 6,7",
          Tarif: "17,42€",
        },
        {
          "Dénomination de l’acte":
            "Exploration du sens chromatique (vision des couleurs)",
          "Cotation lettre clé": "AMY 6",
          Tarif: "15,60€",
        },
      ],
      fieldsDoc: [
        { key: "priseEnCharge", label: "Type de prise en charge" },
        { key: "ordonnance", label: "Terme précisé sur l’ordonnance" },
      ],
      itemsDocs: [
        {
          priseEnCharge: "Bilan orthoptique quel qu’il soit",
          ordonnance: "Bilan orthoptique",
        },
        {
          priseEnCharge: "Si besoin de consultation à domicile",
          ordonnance: "Ajouter à domicile",
        },
        {
          priseEnCharge: "Dépistage de la rétinopathie diabétique",
          ordonnance:
            "Dépistage de la rétinographie diabétique (=RD) par rétinographie non mydriatique couleur + <a href='questionnaires/fiche_patient_retino.odt'>fiche patient</a> complétée",
        },
        {
          priseEnCharge: "Vérification visuelle sans ancienne ordonnance",
          ordonnance: "Vérification de la réfraction / examen de vue",
        },
        {
          priseEnCharge:
            "Renouvellement de correction lunettes / lentilles. Être obligatoirement en possession de son ancienne prescription.",
          ordonnance:
            "Accès direct sans que l’examen soit prescrit. Munissez vous de votre ancienne ordonnance de lunettes (obligatoire).",
        },
      ],
    };
  },
};
</script>

<style lang="stylus">
@import '../css/palette.styl';

.btn-rdv {
  background-color: $accentColor !important;
  margin-bottom: 20px;
  }

i.active {
  color: $accentColor !important;
}

.toggles {
  border-color: white !important;
  border: 0px;
  font-size: 1rem !important;
  color: $darkTextColor;
  background-color: white !important;
  border-bottom: 2px solid $accentColor !important;
  padding-bottom: 30px;
  padding-top: 30px;
  padding: 20px;
  cursor: pointer;
  margin-top: 20px;
}

.toggles .title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
}

.table-title {
  font-size: 1.5rem !important;
}

.toggles i {
  margin-right: 10px;
  color: $pastelGreenColor;
}

#tarifs {
  margin-top: 25px;
  font-size: 1rem !important;
}

#rdv {
  margin-top: 50px;
}

h2 {
  font-size: 1.5rem;
}

.note {
  font-weight: 600;
}

.tables {
  margin-top: 50px;
}

.table-hover tbody tr:hover td, .table-hover tbody tr:hover th {
  background-color: $accentColor;
}


.table-bordered thead td, .table-bordered thead th {
  background-color: $accentColor;
  text-align: center;
  vertical-align: middle;
}

.warning {
  min-height: 40px;
  padding-left: 30px;
  padding-bottom: 10px;
  padding-top: 10px;
  margin-top: 20px;
  border-left: solid 5px $accentColor;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
  /*background-position: left top;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-image: url('../assets/icons_keyword/warning.svg');*/
}

.warning:hover {
  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.2), 0 20px 20px 0 rgba(0, 0, 0, 0.19);
  }

.booking {
  height: 1000px;
  width: 100%;
  border-width: 0px;
}

@media (max-width: 768px) {
  .booking {
    margin-top: 50px;
  }
}
</style>
